// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Caregivers-module__font-s-10___vgVag {
  font-size: 10px !important;
}

.Caregivers-module__font-s-12___WQMJd {
  font-size: 12px !important;
}

.Caregivers-module__font-s-13___vTOYW {
  font-size: 13px !important;
}

.Caregivers-module__font-s-14___Qa_7b {
  font-size: 14px !important;
}

.Caregivers-module__font-s-15___kjWQA {
  font-size: 15px !important;
}

.Caregivers-module__font-s-16___inBjU {
  font-size: 16px !important;
}

.Caregivers-module__font-s-18___u_k1c {
  font-size: 18px !important;
}

.Caregivers-module__font-s-20___VK5TU {
  font-size: 20px !important;
}

.Caregivers-module__font-s-22___OrwzP {
  font-size: 22px !important;
}

.Caregivers-module__font-s-28___q9ABa {
  font-size: 28px !important;
}

.Caregivers-module__font-w-400___JCGJK {
  font-weight: 400 !important;
}

.Caregivers-module__font-w-500___zQ0Bt {
  font-weight: 500 !important;
}

.Caregivers-module__font-w-600___rWhS1 {
  font-weight: 600 !important;
}

.Caregivers-module__font-w-700____itYe {
  font-weight: 700 !important;
}

.Caregivers-module__p-5___mCQwC {
  padding: 5px !important;
}

.Caregivers-module__p-12___VmVJ6 {
  padding: 12px !important;
}

.Caregivers-module__p-16___dgovq {
  padding: 16px !important;
}

.Caregivers-module__p-30___ygGri {
  padding: 30px !important;
}

.Caregivers-module__p-b-0___t44vS {
  padding-bottom: 0 !important;
}

.Caregivers-module__p-b-5___hJLSv {
  padding-bottom: 5px !important;
}

.Caregivers-module__p-b-10___mJE5X {
  padding-bottom: 10px !important;
}

.Caregivers-module__p-b-12___ohzrM {
  padding-bottom: 12px !important;
}

.Caregivers-module__p-b-16___gVh_M {
  padding-bottom: 16px !important;
}

.Caregivers-module__p-b-18___Udg0G {
  padding-bottom: 18px !important;
}

.Caregivers-module__p-b-20___iJW35 {
  padding-bottom: 20px !important;
}

.Caregivers-module__p-b-25___EljfR {
  padding-bottom: 25px !important;
}

.Caregivers-module__p-b-30___RYRva {
  padding-bottom: 30px !important;
}

.Caregivers-module__p-b-50___QPbg7 {
  padding-bottom: 50px !important;
}

.Caregivers-module__p-t-0___Lz9eP {
  padding-top: 0 !important;
}

.Caregivers-module__p-t-12___BoqAh {
  padding-top: 12px !important;
}

.Caregivers-module__p-t-16___ep9fr {
  padding-top: 16px !important;
}

.Caregivers-module__p-t-18___KLN__ {
  padding-top: 18px !important;
}

.Caregivers-module__p-t-20___eO4Ri {
  padding-top: 20px !important;
}

.Caregivers-module__p-t-30___AEhOI {
  padding-top: 30px !important;
}

.Caregivers-module__p-t-40___S_ojF {
  padding-top: 40px !important;
}

.Caregivers-module__p-t-50___F9XOg {
  padding-top: 50px !important;
}

.Caregivers-module__p-l-20___Lj3aC {
  padding-left: 20px !important;
}

.Caregivers-module__p-l-30___rnlb0 {
  padding-left: 30px !important;
}

.Caregivers-module__p-l-40___U1GtS {
  padding-left: 40px !important;
}

.Caregivers-module__p-r-16___hsO6k {
  padding-right: 16px !important;
}

.Caregivers-module__p-r-20___MQUma {
  padding-right: 20px !important;
}

.Caregivers-module__p-r-30___RsVHh {
  padding-right: 30px !important;
}

.Caregivers-module__p-r-50____z1kW {
  padding-right: 50px !important;
}

.Caregivers-module__p-r-60___mC26P {
  padding-right: 60px !important;
}

.Caregivers-module__m-b-1___vA7mD {
  margin-bottom: 1px !important;
}

.Caregivers-module__m-b-2___Sm5Y5 {
  margin-bottom: 2px !important;
}

.Caregivers-module__m-b-6___oDX5h {
  margin-bottom: 6px !important;
}

.Caregivers-module__m-b-8___XxZng {
  margin-bottom: 8px !important;
}

.Caregivers-module__m-b-10___mM8dm {
  margin-bottom: 10px !important;
}

.Caregivers-module__m-b-14___zTUz8 {
  margin-bottom: 14px !important;
}

.Caregivers-module__m-b-16___qfJqQ {
  margin-bottom: 16px !important;
}

.Caregivers-module__m-b-20___HBeq5 {
  margin-bottom: 20px !important;
}

.Caregivers-module__m-b-22___P7C2_ {
  margin-bottom: 22px !important;
}

.Caregivers-module__m-b-24___Eg8Cx {
  margin-bottom: 24px !important;
}

.Caregivers-module__m-b-30___ary_z {
  margin-bottom: 30px !important;
}

.Caregivers-module__m-b-32___SF829 {
  margin-bottom: 32px !important;
}

.Caregivers-module__m-b-40___yLTQz {
  margin-bottom: 40px !important;
}

.Caregivers-module__m-t-2___L1LlJ {
  margin-top: 2px !important;
}

.Caregivers-module__m-t-3___IKNY1 {
  margin-top: 3px !important;
}

.Caregivers-module__m-t-4___hkE6S {
  margin-top: 4px !important;
}

.Caregivers-module__m-t-5___JlcW4 {
  margin-top: 5px !important;
}

.Caregivers-module__m-t-8___GOOWx {
  margin-top: 8px !important;
}

.Caregivers-module__m-t-10___NZsv0 {
  margin-top: 10px !important;
}

.Caregivers-module__m-t-15___U2RkI {
  margin-top: 15px !important;
}

.Caregivers-module__m-t-16___gy1pB {
  margin-top: 16px !important;
}

.Caregivers-module__m-t-20___gHIVP {
  margin-top: 20px !important;
}

.Caregivers-module__m-t-22___hYBF0 {
  margin-top: 22px !important;
}

.Caregivers-module__m-t-30___Nh8I8 {
  margin-top: 30px !important;
}

.Caregivers-module__m-t-32___mwGvw {
  margin-top: 32px !important;
}

.Caregivers-module__m-l-auto___Tt79l {
  margin-left: auto !important;
}

.Caregivers-module__m-l-4___6Oohb {
  margin-left: 4px !important;
}

.Caregivers-module__m-l-5___Fo9nH {
  margin-left: 5px !important;
}

.Caregivers-module__m-l-6___eL5K7 {
  margin-left: 6px !important;
}

.Caregivers-module__m-l-8___Fm0eb {
  margin-left: 8px !important;
}

.Caregivers-module__m-l-10___d6yWl {
  margin-left: 10px !important;
}

.Caregivers-module__m-l-16___koas_ {
  margin-left: 16px !important;
}

.Caregivers-module__m-l-20___IHSNh {
  margin-left: 20px !important;
}

.Caregivers-module__m-l-24___pYpWq {
  margin-left: 24px !important;
}

.Caregivers-module__m-l-30___fPGLc {
  margin-left: 30px !important;
}

.Caregivers-module__m-l-35___koRpg {
  margin-left: 35px !important;
}

.Caregivers-module__m-l-40___qwkXL {
  margin-left: 40px !important;
}

.Caregivers-module__m-r-8____VZ4c {
  margin-right: 8px !important;
}

.Caregivers-module__m-r-10___hjf1s {
  margin-right: 10px !important;
}

.Caregivers-module__m-r-16___PcUHT {
  margin-right: 16px !important;
}

.Caregivers-module__m-r-20___zKBj3 {
  margin-right: 20px !important;
}

.Caregivers-module__m-r-24___m0sar {
  margin-right: 24px !important;
}

.Caregivers-module__m-r-30___dsqPS {
  margin-right: 30px !important;
}

.Caregivers-module__m-r-40___xDVKq {
  margin-right: 40px !important;
}

.Caregivers-module__border-r-3___lF6Ez {
  border-radius: 3px !important;
}

.Caregivers-module__border-r-4___qou4E {
  border-radius: 4px !important;
}

.Caregivers-module__border-r-6___t0Bzp {
  border-radius: 6px !important;
}

.Caregivers-module__border-r-10___qM0Ei {
  border-radius: 10px !important;
}

.Caregivers-module__border-r-12___Gd5gH {
  border-radius: 12px !important;
}

.Caregivers-module__border-r-16___J5kjx {
  border-radius: 16px !important;
}

.Caregivers-module__border-r-50___v85xA {
  border-radius: 50% !important;
}

.Caregivers-module__primary-border___jchoc {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Caregivers-module__primary-border-b___WhaD5 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Caregivers-module__primary-border-t___A_yK7 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Caregivers-module__primary-border-l___PaIBB {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Caregivers-module__primary-border-r___W_JRs {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Caregivers-module__secondary-border___TIsl4 {
  border: 1px solid #637768;
}

.Caregivers-module__secondary-border-b___Wjsuj {
  border-bottom: 1px solid #637768;
}

.Caregivers-module__secondary-border-t___N2fsM {
  border-top: 1px solid #637768;
}

.Caregivers-module__secondary-border-l___y_2Zo {
  border-left: 1px solid #637768;
}

.Caregivers-module__secondary-border-r___qtcJM {
  border-right: 1px solid #637768;
}

.Caregivers-module__gap-0___Q5M4X {
  gap: 0 !important;
}

.Caregivers-module__gap-2___As1pM {
  gap: 2px !important;
}

.Caregivers-module__gap-4___fNAMU {
  gap: 4px !important;
}

.Caregivers-module__gap-5___gM4rF {
  gap: 5px !important;
}

.Caregivers-module__gap-6___N4HBs {
  gap: 6px !important;
}

.Caregivers-module__gap-8___MJpiz {
  gap: 8px !important;
}

.Caregivers-module__gap-10___ZZ98k {
  gap: 10px !important;
}

.Caregivers-module__gap-12___OmjCj {
  gap: 12px !important;
}

.Caregivers-module__gap-14___YqEtO {
  gap: 14px !important;
}

.Caregivers-module__gap-16___b6CbM {
  gap: 16px !important;
}

.Caregivers-module__gap-18___sq0Dd {
  gap: 18px !important;
}

.Caregivers-module__gap-20___anWWN {
  gap: 20px !important;
}

.Caregivers-module__gap-24___hCuB2 {
  gap: 24px !important;
}

.Caregivers-module__gap-26___QlYD6 {
  gap: 26px !important;
}

.Caregivers-module__gap-30___P_9_9 {
  gap: 30px !important;
}

.Caregivers-module__gap-32___dhfnS {
  gap: 32px !important;
}

.Caregivers-module__gap-40___QgEFd {
  gap: 40px !important;
}

.Caregivers-module__gap-50___tasSW {
  gap: 50px !important;
}

.Caregivers-module__flex-1___iGvBs {
  flex: 1;
}

.Caregivers-module__flex-none___sZSXG {
  flex: none !important;
}

.Caregivers-module__flex-column___gPFtV {
  display: flex;
  flex-direction: column !important;
}

.Caregivers-module__flex-row___jY4uk {
  display: flex;
  flex-direction: row !important;
}

.Caregivers-module__vertically-centered___dsPMf {
  display: flex;
  align-items: center !important;
}

.Caregivers-module__horizontally-centered___wwdCN {
  display: flex;
  justify-content: center !important;
}

.Caregivers-module__horizontally-end___z9vtk {
  display: flex;
  justify-content: end !important;
}

.Caregivers-module__vertically-start___q6WKc {
  display: flex;
  align-items: start !important;
}

.Caregivers-module__space-between___rmptt {
  display: flex;
  justify-content: space-between !important;
}

.Caregivers-module__flex-wrap___KYvNy {
  flex-wrap: wrap !important;
}

.Caregivers-module__height-100___oW7hc {
  height: 100%;
}

.Caregivers-module__width-50___eAfTC {
  width: 50% !important;
}

.Caregivers-module__width-100___g2WcR {
  width: 100%;
}

.Caregivers-module__cursor-pointer___RJ2ox {
  cursor: pointer;
}

.Caregivers-module__cursor-not-allowed___vRtAk {
  cursor: not-allowed !important;
}

.Caregivers-module__absolute-centered___n86b3 {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Caregivers-module__absolute___ICRl8 {
  position: absolute;
}

.Caregivers-module__relative___WXAqf {
  position: relative;
}

.Caregivers-module__fixed___WUvJo {
  position: fixed;
}

.Caregivers-module__visible___vYRQa {
  opacity: 1;
}

.Caregivers-module__invisible___p_KqQ {
  opacity: 0;
}

.Caregivers-module__col-90___RwFo1 {
  width: 90% !important;
}

.Caregivers-module__col-auto___rr2VH {
  width: auto !important;
}

.Caregivers-module__medical-tabs___m2D2V {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Caregivers-module__medical-table-new___XF1Tb {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Caregivers-module__medical-table-new___XF1Tb:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Caregivers-module__medical-table-new___XF1Tb::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Caregivers-module__medical-table-new___XF1Tb::-webkit-scrollbar-track {
  display: none;
}
.Caregivers-module__medical-table-new___XF1Tb.Caregivers-module__no-pagination___qb9ke {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Caregivers-module__medical-table-new___XF1Tb.Caregivers-module__no-pagination___qb9ke:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Caregivers-module__medical-table-new___XF1Tb.Caregivers-module__no-pagination___qb9ke::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Caregivers-module__medical-table-new___XF1Tb.Caregivers-module__no-pagination___qb9ke::-webkit-scrollbar-track {
  display: none;
}

.Caregivers-module__medical-table-empty___Rik_C {
  padding: 14px 40px !important;
}

.Caregivers-module__icon-btn___ckCmp {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Caregivers-module__search-icon___Clneh {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Caregivers-module__disable-select___br7Pm {
  user-select: none;
}

.Caregivers-module__break-word___n6yAL {
  word-break: break-word;
}

.Caregivers-module__popup-clear-btn___LUP0g {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Caregivers-module__scroll-m-b-20___pOrER {
  scroll-margin-bottom: 20px;
}

.Caregivers-module__section___SZRnE {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Caregivers-module__controlsRow___Ua4Vb {
  display: flex;
  justify-content: flex-start;
}

.Caregivers-module__controlGroup___vxpU5 {
  display: flex;
  align-items: center;
  gap: 8px;
}

.Caregivers-module__controlLabel___YMWs1 {
  margin: 0;
  color: #375844;
  font-size: 13px;
}

.Caregivers-module__select___TfB6_ {
  min-width: 124px;
  max-width: 124px;
}

.Caregivers-module__group___LkwJC {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.Caregivers-module__groupTitle___hhNZF {
  margin: 0;
  color: #6e7c76;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  font-size: 12px !important;
}

.Caregivers-module__caregiverBlock___TYW6N {
  padding-bottom: 16px;
  border-bottom: 1px solid rgba(55, 88, 68, 0.16);
}
.Caregivers-module__caregiverBlock___TYW6N:last-of-type {
  padding-bottom: 0;
  border-bottom: 0;
}

.Caregivers-module__caregiverHeader___iKo8Y {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.Caregivers-module__caregiverTitle___TbWJa {
  margin: 0;
  color: #375844;
}

.Caregivers-module__primaryBadge___Vf2nM {
  padding: 4px 10px;
  border-radius: 999px;
  background: rgba(111, 168, 128, 0.18);
  color: #375844;
  font-size: 12px;
  font-weight: 600;
}

.Caregivers-module__grid___JPUP4 {
  display: grid;
  column-gap: 16px;
  row-gap: 10px;
  margin-bottom: 12px;
  grid-template-columns: repeat(4, minmax(160px, 1fr));
}

.Caregivers-module__actionsRow___fwEeA {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
}

.Caregivers-module__addRow___NhBHo {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.Caregivers-module__addButton___o0SPn {
  align-self: flex-start;
}
.Caregivers-module__addButton___o0SPn > img {
  width: 18px;
  height: 18px;
}
.Caregivers-module__addButton___o0SPn > span {
  font-size: 14px !important;
}

.Caregivers-module__toggleButton___SCLG8 {
  align-self: flex-start;
  padding: 0;
  min-width: auto !important;
  background: transparent !important;
}
.Caregivers-module__toggleButton___SCLG8 > span {
  font-size: 14px !important;
}
.Caregivers-module__toggleButton___SCLG8:hover, .Caregivers-module__toggleButton___SCLG8:focus-visible {
  background: transparent !important;
}

.Caregivers-module__emptyState___Gzx5z {
  color: #6e7c76;
}

.Caregivers-module__secondaryActionButton___vY5xs {
  padding: 0;
  min-width: auto !important;
  background: transparent !important;
}
.Caregivers-module__secondaryActionButton___vY5xs > span {
  font-size: 14px !important;
}
.Caregivers-module__secondaryActionButton___vY5xs:hover, .Caregivers-module__secondaryActionButton___vY5xs:focus-visible {
  background: transparent !important;
}

@media (max-width: 1400px) {
  .Caregivers-module__grid___JPUP4 {
    grid-template-columns: repeat(3, minmax(160px, 1fr));
  }
}
@media (max-width: 1100px) {
  .Caregivers-module__grid___JPUP4 {
    grid-template-columns: repeat(2, minmax(160px, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/PatientDetails/fragments/Profile/forms/Caregivers/Caregivers.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,2BAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA8pBF;;AA3pBA;EACE,SAAA;EACA,cAAA;EACA,eAAA;AA8pBF;;AA3pBA;EACE,gBAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA8pBF;;AA3pBA;EACE,SAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;EACA,0BAAA;AA8pBF;;AA3pBA;EACE,oBAAA;EACA,+CAAA;AA8pBF;AA5pBE;EACE,iBAAA;EACA,gBAAA;AA8pBJ;;AA1pBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA6pBF;;AA1pBA;EACE,SAAA;EACA,cAAA;AA6pBF;;AA1pBA;EACE,iBAAA;EACA,oBAAA;EACA,qCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,oDAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,SAAA;AA6pBF;;AA1pBA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA6pBF;;AA1pBA;EACE,sBAAA;AA6pBF;AA3pBE;EACE,WAAA;EACA,YAAA;AA6pBJ;AA1pBE;EACE,0BAAA;AA4pBJ;;AAxpBA;EACE,sBAAA;EACA,UAAA;EACA,0BAAA;EACA,kCAAA;AA2pBF;AAzpBE;EACE,0BAAA;AA2pBJ;AAxpBE;EAEE,kCAAA;AAypBJ;;AArpBA;EACE,cAAA;AAwpBF;;AArpBA;EACE,UAAA;EACA,0BAAA;EACA,kCAAA;AAwpBF;AAtpBE;EACE,0BAAA;AAwpBJ;AArpBE;EAEE,kCAAA;AAspBJ;;AAlpBA;EACE;IACE,oDAAA;EAqpBF;AACF;AAlpBA;EACE;IACE,oDAAA;EAopBF;AACF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.controlsRow {\n  display: flex;\n  justify-content: flex-start;\n}\n\n.controlGroup {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.controlLabel {\n  margin: 0;\n  color: #375844;\n  font-size: 13px;\n}\n\n.select {\n  min-width: 124px;\n  max-width: 124px;\n}\n\n.group {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.groupTitle {\n  margin: 0;\n  color: #6e7c76;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  font-size: 12px !important;\n}\n\n.caregiverBlock {\n  padding-bottom: 16px;\n  border-bottom: 1px solid rgba(55, 88, 68, 0.16);\n\n  &:last-of-type {\n    padding-bottom: 0;\n    border-bottom: 0;\n  }\n}\n\n.caregiverHeader {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.caregiverTitle {\n  margin: 0;\n  color: #375844;\n}\n\n.primaryBadge {\n  padding: 4px 10px;\n  border-radius: 999px;\n  background: rgba(111, 168, 128, 0.18);\n  color: #375844;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.grid {\n  display: grid;\n  column-gap: 16px;\n  row-gap: 10px;\n  margin-bottom: 12px;\n  grid-template-columns: repeat(4, minmax(160px, 1fr));\n}\n\n.actionsRow {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 12px;\n}\n\n.addRow {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.addButton {\n  align-self: flex-start;\n\n  & > img {\n    width: 18px;\n    height: 18px;\n  }\n\n  & > span {\n    font-size: 14px !important;\n  }\n}\n\n.toggleButton {\n  align-self: flex-start;\n  padding: 0;\n  min-width: auto !important;\n  background: transparent !important;\n\n  & > span {\n    font-size: 14px !important;\n  }\n\n  &:hover,\n  &:focus-visible {\n    background: transparent !important;\n  }\n}\n\n.emptyState {\n  color: #6e7c76;\n}\n\n.secondaryActionButton {\n  padding: 0;\n  min-width: auto !important;\n  background: transparent !important;\n\n  & > span {\n    font-size: 14px !important;\n  }\n\n  &:hover,\n  &:focus-visible {\n    background: transparent !important;\n  }\n}\n\n@media (max-width: 1400px) {\n  .grid {\n    grid-template-columns: repeat(3, minmax(160px, 1fr));\n  }\n}\n\n@media (max-width: 1100px) {\n  .grid {\n    grid-template-columns: repeat(2, minmax(160px, 1fr));\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Caregivers-module__font-s-10___vgVag`,
	"fontS12": `Caregivers-module__font-s-12___WQMJd`,
	"fontS13": `Caregivers-module__font-s-13___vTOYW`,
	"fontS14": `Caregivers-module__font-s-14___Qa_7b`,
	"fontS15": `Caregivers-module__font-s-15___kjWQA`,
	"fontS16": `Caregivers-module__font-s-16___inBjU`,
	"fontS18": `Caregivers-module__font-s-18___u_k1c`,
	"fontS20": `Caregivers-module__font-s-20___VK5TU`,
	"fontS22": `Caregivers-module__font-s-22___OrwzP`,
	"fontS28": `Caregivers-module__font-s-28___q9ABa`,
	"fontW400": `Caregivers-module__font-w-400___JCGJK`,
	"fontW500": `Caregivers-module__font-w-500___zQ0Bt`,
	"fontW600": `Caregivers-module__font-w-600___rWhS1`,
	"fontW700": `Caregivers-module__font-w-700____itYe`,
	"p5": `Caregivers-module__p-5___mCQwC`,
	"p12": `Caregivers-module__p-12___VmVJ6`,
	"p16": `Caregivers-module__p-16___dgovq`,
	"p30": `Caregivers-module__p-30___ygGri`,
	"pB0": `Caregivers-module__p-b-0___t44vS`,
	"pB5": `Caregivers-module__p-b-5___hJLSv`,
	"pB10": `Caregivers-module__p-b-10___mJE5X`,
	"pB12": `Caregivers-module__p-b-12___ohzrM`,
	"pB16": `Caregivers-module__p-b-16___gVh_M`,
	"pB18": `Caregivers-module__p-b-18___Udg0G`,
	"pB20": `Caregivers-module__p-b-20___iJW35`,
	"pB25": `Caregivers-module__p-b-25___EljfR`,
	"pB30": `Caregivers-module__p-b-30___RYRva`,
	"pB50": `Caregivers-module__p-b-50___QPbg7`,
	"pT0": `Caregivers-module__p-t-0___Lz9eP`,
	"pT12": `Caregivers-module__p-t-12___BoqAh`,
	"pT16": `Caregivers-module__p-t-16___ep9fr`,
	"pT18": `Caregivers-module__p-t-18___KLN__`,
	"pT20": `Caregivers-module__p-t-20___eO4Ri`,
	"pT30": `Caregivers-module__p-t-30___AEhOI`,
	"pT40": `Caregivers-module__p-t-40___S_ojF`,
	"pT50": `Caregivers-module__p-t-50___F9XOg`,
	"pL20": `Caregivers-module__p-l-20___Lj3aC`,
	"pL30": `Caregivers-module__p-l-30___rnlb0`,
	"pL40": `Caregivers-module__p-l-40___U1GtS`,
	"pR16": `Caregivers-module__p-r-16___hsO6k`,
	"pR20": `Caregivers-module__p-r-20___MQUma`,
	"pR30": `Caregivers-module__p-r-30___RsVHh`,
	"pR50": `Caregivers-module__p-r-50____z1kW`,
	"pR60": `Caregivers-module__p-r-60___mC26P`,
	"mB1": `Caregivers-module__m-b-1___vA7mD`,
	"mB2": `Caregivers-module__m-b-2___Sm5Y5`,
	"mB6": `Caregivers-module__m-b-6___oDX5h`,
	"mB8": `Caregivers-module__m-b-8___XxZng`,
	"mB10": `Caregivers-module__m-b-10___mM8dm`,
	"mB14": `Caregivers-module__m-b-14___zTUz8`,
	"mB16": `Caregivers-module__m-b-16___qfJqQ`,
	"mB20": `Caregivers-module__m-b-20___HBeq5`,
	"mB22": `Caregivers-module__m-b-22___P7C2_`,
	"mB24": `Caregivers-module__m-b-24___Eg8Cx`,
	"mB30": `Caregivers-module__m-b-30___ary_z`,
	"mB32": `Caregivers-module__m-b-32___SF829`,
	"mB40": `Caregivers-module__m-b-40___yLTQz`,
	"mT2": `Caregivers-module__m-t-2___L1LlJ`,
	"mT3": `Caregivers-module__m-t-3___IKNY1`,
	"mT4": `Caregivers-module__m-t-4___hkE6S`,
	"mT5": `Caregivers-module__m-t-5___JlcW4`,
	"mT8": `Caregivers-module__m-t-8___GOOWx`,
	"mT10": `Caregivers-module__m-t-10___NZsv0`,
	"mT15": `Caregivers-module__m-t-15___U2RkI`,
	"mT16": `Caregivers-module__m-t-16___gy1pB`,
	"mT20": `Caregivers-module__m-t-20___gHIVP`,
	"mT22": `Caregivers-module__m-t-22___hYBF0`,
	"mT30": `Caregivers-module__m-t-30___Nh8I8`,
	"mT32": `Caregivers-module__m-t-32___mwGvw`,
	"mLAuto": `Caregivers-module__m-l-auto___Tt79l`,
	"mL4": `Caregivers-module__m-l-4___6Oohb`,
	"mL5": `Caregivers-module__m-l-5___Fo9nH`,
	"mL6": `Caregivers-module__m-l-6___eL5K7`,
	"mL8": `Caregivers-module__m-l-8___Fm0eb`,
	"mL10": `Caregivers-module__m-l-10___d6yWl`,
	"mL16": `Caregivers-module__m-l-16___koas_`,
	"mL20": `Caregivers-module__m-l-20___IHSNh`,
	"mL24": `Caregivers-module__m-l-24___pYpWq`,
	"mL30": `Caregivers-module__m-l-30___fPGLc`,
	"mL35": `Caregivers-module__m-l-35___koRpg`,
	"mL40": `Caregivers-module__m-l-40___qwkXL`,
	"mR8": `Caregivers-module__m-r-8____VZ4c`,
	"mR10": `Caregivers-module__m-r-10___hjf1s`,
	"mR16": `Caregivers-module__m-r-16___PcUHT`,
	"mR20": `Caregivers-module__m-r-20___zKBj3`,
	"mR24": `Caregivers-module__m-r-24___m0sar`,
	"mR30": `Caregivers-module__m-r-30___dsqPS`,
	"mR40": `Caregivers-module__m-r-40___xDVKq`,
	"borderR3": `Caregivers-module__border-r-3___lF6Ez`,
	"borderR4": `Caregivers-module__border-r-4___qou4E`,
	"borderR6": `Caregivers-module__border-r-6___t0Bzp`,
	"borderR10": `Caregivers-module__border-r-10___qM0Ei`,
	"borderR12": `Caregivers-module__border-r-12___Gd5gH`,
	"borderR16": `Caregivers-module__border-r-16___J5kjx`,
	"borderR50": `Caregivers-module__border-r-50___v85xA`,
	"primaryBorder": `Caregivers-module__primary-border___jchoc`,
	"primaryBorderB": `Caregivers-module__primary-border-b___WhaD5`,
	"primaryBorderT": `Caregivers-module__primary-border-t___A_yK7`,
	"primaryBorderL": `Caregivers-module__primary-border-l___PaIBB`,
	"primaryBorderR": `Caregivers-module__primary-border-r___W_JRs`,
	"secondaryBorder": `Caregivers-module__secondary-border___TIsl4`,
	"secondaryBorderB": `Caregivers-module__secondary-border-b___Wjsuj`,
	"secondaryBorderT": `Caregivers-module__secondary-border-t___N2fsM`,
	"secondaryBorderL": `Caregivers-module__secondary-border-l___y_2Zo`,
	"secondaryBorderR": `Caregivers-module__secondary-border-r___qtcJM`,
	"gap0": `Caregivers-module__gap-0___Q5M4X`,
	"gap2": `Caregivers-module__gap-2___As1pM`,
	"gap4": `Caregivers-module__gap-4___fNAMU`,
	"gap5": `Caregivers-module__gap-5___gM4rF`,
	"gap6": `Caregivers-module__gap-6___N4HBs`,
	"gap8": `Caregivers-module__gap-8___MJpiz`,
	"gap10": `Caregivers-module__gap-10___ZZ98k`,
	"gap12": `Caregivers-module__gap-12___OmjCj`,
	"gap14": `Caregivers-module__gap-14___YqEtO`,
	"gap16": `Caregivers-module__gap-16___b6CbM`,
	"gap18": `Caregivers-module__gap-18___sq0Dd`,
	"gap20": `Caregivers-module__gap-20___anWWN`,
	"gap24": `Caregivers-module__gap-24___hCuB2`,
	"gap26": `Caregivers-module__gap-26___QlYD6`,
	"gap30": `Caregivers-module__gap-30___P_9_9`,
	"gap32": `Caregivers-module__gap-32___dhfnS`,
	"gap40": `Caregivers-module__gap-40___QgEFd`,
	"gap50": `Caregivers-module__gap-50___tasSW`,
	"flex1": `Caregivers-module__flex-1___iGvBs`,
	"flexNone": `Caregivers-module__flex-none___sZSXG`,
	"flexColumn": `Caregivers-module__flex-column___gPFtV`,
	"flexRow": `Caregivers-module__flex-row___jY4uk`,
	"verticallyCentered": `Caregivers-module__vertically-centered___dsPMf`,
	"horizontallyCentered": `Caregivers-module__horizontally-centered___wwdCN`,
	"horizontallyEnd": `Caregivers-module__horizontally-end___z9vtk`,
	"verticallyStart": `Caregivers-module__vertically-start___q6WKc`,
	"spaceBetween": `Caregivers-module__space-between___rmptt`,
	"flexWrap": `Caregivers-module__flex-wrap___KYvNy`,
	"height100": `Caregivers-module__height-100___oW7hc`,
	"width50": `Caregivers-module__width-50___eAfTC`,
	"width100": `Caregivers-module__width-100___g2WcR`,
	"cursorPointer": `Caregivers-module__cursor-pointer___RJ2ox`,
	"cursorNotAllowed": `Caregivers-module__cursor-not-allowed___vRtAk`,
	"absoluteCentered": `Caregivers-module__absolute-centered___n86b3`,
	"absolute": `Caregivers-module__absolute___ICRl8`,
	"relative": `Caregivers-module__relative___WXAqf`,
	"fixed": `Caregivers-module__fixed___WUvJo`,
	"visible": `Caregivers-module__visible___vYRQa`,
	"invisible": `Caregivers-module__invisible___p_KqQ`,
	"col90": `Caregivers-module__col-90___RwFo1`,
	"colAuto": `Caregivers-module__col-auto___rr2VH`,
	"medicalTabs": `Caregivers-module__medical-tabs___m2D2V`,
	"medicalTableNew": `Caregivers-module__medical-table-new___XF1Tb`,
	"noPagination": `Caregivers-module__no-pagination___qb9ke`,
	"medicalTableEmpty": `Caregivers-module__medical-table-empty___Rik_C`,
	"iconBtn": `Caregivers-module__icon-btn___ckCmp`,
	"searchIcon": `Caregivers-module__search-icon___Clneh`,
	"disableSelect": `Caregivers-module__disable-select___br7Pm`,
	"breakWord": `Caregivers-module__break-word___n6yAL`,
	"popupClearBtn": `Caregivers-module__popup-clear-btn___LUP0g`,
	"scrollMB20": `Caregivers-module__scroll-m-b-20___pOrER`,
	"section": `Caregivers-module__section___SZRnE`,
	"controlsRow": `Caregivers-module__controlsRow___Ua4Vb`,
	"controlGroup": `Caregivers-module__controlGroup___vxpU5`,
	"controlLabel": `Caregivers-module__controlLabel___YMWs1`,
	"select": `Caregivers-module__select___TfB6_`,
	"group": `Caregivers-module__group___LkwJC`,
	"groupTitle": `Caregivers-module__groupTitle___hhNZF`,
	"caregiverBlock": `Caregivers-module__caregiverBlock___TYW6N`,
	"caregiverHeader": `Caregivers-module__caregiverHeader___iKo8Y`,
	"caregiverTitle": `Caregivers-module__caregiverTitle___TbWJa`,
	"primaryBadge": `Caregivers-module__primaryBadge___Vf2nM`,
	"grid": `Caregivers-module__grid___JPUP4`,
	"actionsRow": `Caregivers-module__actionsRow___fwEeA`,
	"addRow": `Caregivers-module__addRow___NhBHo`,
	"addButton": `Caregivers-module__addButton___o0SPn`,
	"toggleButton": `Caregivers-module__toggleButton___SCLG8`,
	"emptyState": `Caregivers-module__emptyState___Gzx5z`,
	"secondaryActionButton": `Caregivers-module__secondaryActionButton___vY5xs`
};
module.exports = ___CSS_LOADER_EXPORT___;
